import { render, staticRenderFns } from "./RecordCard.vue?vue&type=template&id=46a00755&scoped=true&"
import script from "./RecordCard.vue?vue&type=script&lang=js&"
export * from "./RecordCard.vue?vue&type=script&lang=js&"
import style0 from "./RecordCard.vue?vue&type=style&index=0&id=46a00755&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a00755",
  null
  
)

export default component.exports